module.exports = __webpack_public_path__ + "img/side length.96c42f37.png";